import React, { useEffect, useMemo, useState, useRef } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { getTop10NamesByYearInfo } from "../slices/storeSlice";
import SearchDataChart from "./SearchDataChart";
import { getSearchNameInfo, setSearchNameInfo } from "../slices/storeSlice";
import Swal from "sweetalert2";
import _ from "lodash";
import globalValues from "../store/globalValues";

//region style
const Subtitle = styled.p`
    text-align: center;
    font-weight: bold;
    color: #064645;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                margin-top: 45px;
                margin-bottom: 16px;
                font-size: 40px;
            `;
        } else {
            return css`
                margin-top: 150px;
                margin-bottom: 45px;
                font-size: 50px;
            `;
        }
    }}
`;

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                margin-bottom: 30px;
            `;
        } else {
            return css`
                margin-bottom: 60px;
            `;
        }
    }}
`;

const Column = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Layer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Part3BackGround = styled.div`
    width: 100%;
    border-radius: 30px;
    background: #cae7e2;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding: 5%;
            `;
        } else {
            return css`
                height: 790px;
            `;
        }
    }}
`;

const ShareToFriends = styled.div`
    display: flex;
    align-items: center;
    color: rgb(16, 107, 102);

    span {
        padding: 10px 5px;
        border-bottom: 1px solid rgb(16, 107, 102);
        margin: auto 5px;
    }

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                justify-content: center;
                font-size: 20px;
                padding: 20px 0;
            `;
        } else {
            return css`
                justify-content: end;
                padding: 70px 60px;
                font-size: 22px;
            `;
        }
    }}
`;

const ShareIcon = styled.a`
    background-image: url("${process.env.PUBLIC_URL}/images/03-share-button.png");
    width: 25px;
    height: 25px;
    background-size: cover;
    cursor: pointer;
    opacity: 0.9;
    :hover {
        opacity: 1;
    }
`;

const ShareFriendName = styled.input`
    border-radius: 5px;
    font-family: -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft JhengHei UI", "Microsoft YaHei",
        "細明體_HKSCS", "Kai_MSCS", "Ming_MSCS", "Ming-MSCS-DSI";
    border: none;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                width: 60px;
                text-align: center;
            `;
        } else {
            return css`
                width: 48px;
            `;
        }
    }}
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 5px;
    }
`;

const BigYellowPerson = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("${process.env.PUBLIC_URL}/images/03-yellow-person.png");
    background-size: cover;
    font-size: 58px;
    color: rgb(28, 149, 158);
    font-weight: bold;
    cursor: pointer;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                width: 180px;
                height: 216px;
                div:first-child {
                    margin-top: 42px;
                    font-size: 48px;
                }

                div:nth-child(2) {
                    margin-top: 58px;
                }
            `;
        } else {
            return css`
                width: 258px;
                height: 310px;
                div:first-child {
                    margin-top: 65px;
                }

                div:nth-child(2) {
                    margin-top: 90px;
                }
            `;
        }
    }}
`;

const BigGreenPerson = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("${process.env.PUBLIC_URL}/images/03-green-person.png");
    background-size: 100%;
    background-repeat: no-repeat;
    font-size: 26px;
    color: white;
    font-weight: bold;
    cursor: pointer;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                width: 60px;
                height: 79px;
                margin: 0 4px;
                div:first-child {
                    margin-top: 14px;
                    font-size: 16px;
                }

                div:nth-child(2) {
                    margin-top: 18px;
                    font-size: 20px;
                }
            `;
        } else {
            return css`
                width: 108px;
                height: 130px;
                margin-right: 12px;
                div:first-child {
                    margin-top: 27px;
                }

                div:nth-child(2) {
                    margin-top: 34px;
                    font-size: 34px;
                }
            `;
        }
    }}
`;

const PersonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    color: rgb(101, 177, 165);
    div {
        margin-top: 10px;
    }
    span {
        font-size: 14px;
    }
`;

const YearSelecterContainer = styled.select`
    margin: 0 5% 16px 5%;
    width: 90%;
    height: 48px;
    border-radius: 10px;
    border: none;
    font-size: 18px;
    font-weight: bold;
    padding-left: 32px;
    background: url("${process.env.PUBLIC_URL}/images/arrow.png") no-repeat scroll right center white;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 10px;
    }
`;

const YearSelecterText = styled.p`
    color: #106b64;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
`;

//endregion

//region style
const SearchContainer = styled.div`
    z-index: 999;
    top: 0;
    position: fixed;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 80%,
        rgba(255, 255, 255, 0) 100%
    );
    width: 100%;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding-top: 0;
                position: relative;
            `;
        } else {
            return css`
                padding-top: 30px;
            `;
        }
    }}
`;

const FBbuttonContainer = styled.div`
    transform: scale(1.2, 1.2);
    display: flex;
    justify-content: center;
    align-items: center;
    &.top-bar-inner {
        margin-left: auto;
        margin-right: 30px;
    }
`;

const ChartBG = styled.div`
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                display: flex;
                flex-direction: column;
                min-height: 100%;
            `;
        } else {
            return css`
                width: 820px;
                height: 90%;
            `;
        }
    }}
`;

const BGTopLayer = styled.div`
    display: flex;
    width: 100%;
    position: relative;
`;

const BGTriangle = styled.div`
    //background-color: #2ab193;
    width: 90px;
    height: 90px;
    -webkit-clip-path: polygon(0 0, 0% 100%, 100% 100%);
    clip-path: polygon(0 0, 0% 100%, 100% 100%);
`;

const BGSquare = styled.div`
    display: flex;
    align-items: center;
    //background-color: #2ab193;
    height: 90px;
    flex: 1;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding-left: 20px;
            `;
        } else {
            return css`
                padding-left: 40px;
                padding-top: 10px;
            `;
        }
    }}
`;

const TableContent = styled.div`
    //background-color: #2ab193;
    height: 100%;
    padding: 0 30px 30px 30px;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                padding: 0 10px 30px 10px;
                flex: 1;
            `;
        } else {
            return css`
                width: 820px;
                height: 640px;
            `;
        }
    }}
`;

const LeftCornerYear = styled.div`
    width: 90px;
    height: 34px;
    background-color: rgb(15, 92, 72);
    border-radius: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 16px;
`;

const CloseClick = styled.div`
    background-image: url("${process.env.PUBLIC_URL}/images/popUp-close.png");
    width: 20px;
    height: 20px;
    background-size: cover;
    cursor: pointer;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                position: absolute;
                right: 15px;
                top: 20px;
            `;
        } else {
            return css``;
        }
    }}//position: absolute;
        //right: 15px;
        //top: 20px;
        //transform: translate3d(-30px, 30px , 1px);
        //float: right;
`;

const ChartContainer = styled.div`
    z-index: 999;
    //position: fixed;
    transition: 0.3s all ease-in-out;
    //left: 50%;
    //transform: translateX(-50%);
    background-color: white;
    box-shadow: 0 -5px 40px rgba(0, 0, 0, 0.3);
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 5px;
    overscroll-behavior: contain;
    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
            return css`
                //top:5%;
                //min-width:350px;
                min-height: 350px;
            `;
        } else {
            return css`
                //top:5vh;
                max-width: 980px;
                min-height: 300px;
            `;
        }
    }}
`;

const Mask = styled.div`
    background-color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 998;
    display: block;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(6px);
    transition: 0.3s all ease-in-out;
`;

const ResultYearSelector = styled.select`
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    select::-ms-expand {
        display: none;
    }
    border: none;
    color: white;
    background-color: rgb(4, 106, 92);
    background: url("${process.env.PUBLIC_URL}/images/arrow2.png") 90% 50% no-repeat scroll rgb(4, 106, 92);
    width: 180px;
    height: 40px;
    border-radius: 30px;
    font-size: 30px;
    display: flex;
    text-align: center;
    :focus-visible {
        outline: 2px dashed #cae7e2;
        border-radius: 30px;
    }
`;

const ChartTopBar = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    padding: 35px 50px 0 50px;
    align-items: center;
`;

//endregion

function Part3(_props: any) {
    const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
    const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
    const dispatch = useDispatch();
    const MIN = globalValues.minYear;
    const MAX = globalValues.maxYear;
    let year = MAX;

    const YearSelecter = () => {
        const [value, setValue] = useState(MAX);
        const firstUpdate = useRef(true);

        useMemo(() => {
            if (firstUpdate.current) {
                firstUpdate.current = false;
                return;
            }

            dispatch(getTop10NamesByYearInfo({ year: value }));
            year = value;
        }, [value]);

        const Options = () => {
            let Result = [];
            for (let i = MAX; i >= MIN; i--) {
                Result.push(
                    <option key={i} value={i}>
                        {i}
                    </option>,
                );
            }
            return <>{Result}</>;
        };

        return (
            <>
                <YearSelecterText>請選擇年份</YearSelecterText>
                <YearSelecterContainer value={value} onChange={(e) => setValue(parseInt(e.target.value))}>
                    <Options />
                </YearSelecterContainer>
            </>
        );
    };

    const YearSilder = () => {
        const [value, setValue] = useState(MAX);
        const StepPerMove = 945 / (MAX - MIN);
        const [move, setMove] = useState(0);
        const [yearNeedtoGet, setYearNeedtoGet] = useState(MAX);
        const firstUpdate = useRef(true);

        useEffect(() => {
            changePosition();
        }, [value]);

        const changePosition = () => {
            setMove(StepPerMove * (MAX - value));
        };

        const changeYear = (event: React.ChangeEvent<HTMLInputElement>) => {
            setValue(parseInt(event.target.value));
        };

        useMemo(() => {
            if (firstUpdate.current) {
                firstUpdate.current = false;
                return;
            }

            dispatch(getTop10NamesByYearInfo({ year: value }));
        }, [value]);

        const getData = () => {
            setYearNeedtoGet(value);
            year = value;
        };

        return (
            <>
                <div className="sliderYearDiv">
                    <span style={{ right: `${move}px` }} className="SilderYearText">
                        {value}
                    </span>
                </div>
                <div className="sliderContainer">
                    <div>
                        <input
                            type="range"
                            className="slider"
                            min={MIN}
                            max={MAX}
                            value={value}
                            step="1"
                            onInput={changeYear}
                            onMouseUp={getData}
                            onKeyUp={getData}
                        />
                    </div>
                </div>
                <div className="sliderYearFromTo">
                    <p>{MIN}</p>
                    <p>{MAX}</p>
                </div>
            </>
        );
    };

    const YearChangeOptions = () => {
        let Result = [];

        for (let i = MAX; i >= MIN; i--) {
            Result.push(
                <option key={i} value={i}>
                    {i}年
                </option>,
            );
        }
        return <>{Result}</>;
    };

    function formatNumber(Number: any) {
        return String(Number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const LoopName = () => {
        const top10NamesByYearInfo: any = useSelector((state: RootState) => state.storeSlice.top10NamesByYearInfo);
        const [top10NameByYear_Names, setTop10NameByYear_Names] = useState([]);
        const [top10NameByYear_Counts, setTop10NameByYear_Counts] = useState(new Array(10).fill(0));
        const [friendName, setFriendName] = useState("");
        const [DisplayClassName, setDisplayClassName] = useState("Off");

        useEffect(() => {
            if (top10NamesByYearInfo) {
                setTop10NameByYear_Names(top10NamesByYearInfo.top10NamesByYear.map((m: any) => m.name));
                setTop10NameByYear_Counts(top10NamesByYearInfo.top10NamesByYear.map((m: any) => m.count));
                setFriendName(top10NamesByYearInfo.top10NamesByYear[0].name);
            }
        }, [top10NamesByYearInfo]);

        let ResultPartA = [];
        let ResultPartB = [];
        let ResultPartC = [];

        function isChinese(input: string): boolean {
            return /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF\u{20000}-\u{2A6DF}]/u.test(input);
        }

        // function isChinese(input: string) {
        //   const pattern = new RegExp("[\u4E00-\u9FFF]");
        //   const pattern0 = new RegExp("[\u3000-\u4DFF]");
        //   const pattern2 = new RegExp("[\uE007-\uF6E0]");
        //
        //   let i = 0;
        //   let result = false;
        //   while (i < [...input].length) {
        //     if (pattern.test([...input][i])){
        //       i++
        //     }
        //     else if (pattern0.test([...input][i])){
        //       i++
        //     }
        //     else if (pattern2.test([...input][i])){
        //       i++
        //     }
        //     else
        //       return result
        //   }
        //   result = true
        //   return result
        //
        //   //if(pattern.test(input))
        //   //  return true //中文
        //   //return false //不是中文
        // }

        const Toast = Swal.mixin({
            toast: false,
            showCloseButton: true,
            target: "root",
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mousedown", Swal.clickConfirm);
            },
        });

        function customAlert(text: string) {
            Toast.fire({
                icon: "warning",
                title: text,
            });
        }

        const open = (name: string) => {
            if (!isChinese(name)) {
                if (isMobile || isTablet) {
                    alert("請輸入中文名字");
                } else {
                    customAlert("請輸入中文名字");
                }
                document.getElementById("ShareName")?.focus();
            } else if (name.length === 0) {
                if (isMobile || isTablet) {
                    alert("請輸入名字");
                } else {
                    customAlert("請輸入名字");
                }
                document.getElementById("ShareName")?.focus();
            } else if (year > MAX || year < MIN) {
                if (isMobile || isTablet) {
                    alert("請選擇正確時期");
                } else {
                    customAlert("請選擇正確時期");
                }
            } else if (name.length > 6) {
                if (isMobile || isTablet) {
                    alert("請檢查名字長度");
                } else {
                    customAlert("請檢查名字長度");
                }
                document.getElementById("ShareName")?.focus();
            } else {
                dispatch(getSearchNameInfo({ year: year, familyName: "", name: name }));
                setDisplayClassName("On");
            }
        };

        const setFriendNameAndSerach = (inputName: any) => {
            setFriendName(inputName);
            open(inputName);
        };

        const SerachName = () => {
            open(friendName);
        };

        const ShareFriendNameEnter = (event: any) => {
            if (event.key === "Enter") {
                event.stopPropagation();
                SerachName();
            }
        };

        const close = () => {
            setDisplayClassName("Off");
            dispatch(setSearchNameInfo(null));
        };

        const [displayValue, SetDisplayValue] = useState(MAX);

        const changeYear = (targetValue: any) => {
            SetDisplayValue(targetValue);
            year = targetValue;
            dispatch(getSearchNameInfo({ year: targetValue, familyName: "", name: friendName }));
        };

        const YearSelecter = () => {
            return (
                <ResultYearSelector
                    id="test"
                    value={displayValue}
                    onChange={(e) => changeYear(parseInt(e.target.value))}
                >
                    <YearChangeOptions />
                </ResultYearSelector>
            );
        };

        let origin = window.location.origin;
        let encodeURI_url = "";
        let URL = origin + "/" + process.env.PUBLIC_URL + "?GivenName=" + friendName + "&Year=" + displayValue;
        encodeURI_url = encodeURIComponent(URL);

        const FBshareButton = () => {
            return (
                // <iframe src={"https://www.facebook.com/plugins/share_button.php?href=" + encodeURI_url + "&layout=button&size=large&width=69&height=28&appId"}
                //         width="69"
                //         height="28"
                //         allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
                // </iframe>
                <a
                    target={"_blank"}
                    href={`https://www.facebook.com/sharer.php?t=Macau%20Statistics%20and%20Census%20Service%20(DSEC)&u=${encodeURI_url}`}
                >
                    <img className={"fb-icon"} src={`${process.env.PUBLIC_URL}/images/facebook-icon.png`} />
                </a>
            );
        };

        ResultPartA.push(
            <PersonContainer key={0}>
                <BigYellowPerson
                    onClick={() => setFriendNameAndSerach(top10NameByYear_Names[0])}
                    onMouseOver={() => setFriendName(top10NameByYear_Names[0])}
                >
                    <div>{top10NameByYear_Names[0]}</div>
                    <div>1</div>
                </BigYellowPerson>
                <div>
                    {formatNumber(top10NameByYear_Counts[0])}
                    <span>次</span>
                </div>
            </PersonContainer>,
        );

        for (let i = 1; i < 6; i++) {
            ResultPartB.push(
                <PersonContainer key={i}>
                    <BigGreenPerson
                        onClick={() => setFriendNameAndSerach(top10NameByYear_Names[i])}
                        onMouseOver={() => setFriendName(top10NameByYear_Names[i])}
                    >
                        <div>{top10NameByYear_Names[i]}</div>
                        <div>{i + 1}</div>
                    </BigGreenPerson>
                    <div>
                        {formatNumber(top10NameByYear_Counts[i])}
                        <span>次</span>
                    </div>
                </PersonContainer>,
            );
        }

        for (let i = 6; i < 10; i++) {
            ResultPartC.push(
                <PersonContainer key={i}>
                    <BigGreenPerson
                        onClick={() => setFriendNameAndSerach(top10NameByYear_Names[i])}
                        onMouseOver={() => setFriendName(top10NameByYear_Names[i])}
                    >
                        <div>{top10NameByYear_Names[i]}</div>
                        <div>{i + 1}</div>
                    </BigGreenPerson>
                    <div>
                        {formatNumber(top10NameByYear_Counts[i])}
                        <span>次</span>
                    </div>
                </PersonContainer>,
            );
        }

        //<ShareIcon href={"https://www.facebook.com/sharer.php?u="+encodeURI_url}/>
        if (isMobile || isTablet) {
            return (
                <>
                    <Layer>{ResultPartA}</Layer>
                    <ShareToFriends>
                        <div>
                            分享給你身邊叫
                            <ShareFriendName
                                onKeyDown={(event) => ShareFriendNameEnter(event)}
                                type="text"
                                id="ShareName"
                                value={friendName}
                                onChange={(e) => setFriendName(e.target.value)}
                            />
                            的朋友吧！
                        </div>
                        <ShareIcon target={"_blank"} onClick={() => SerachName()} />
                    </ShareToFriends>
                    <Container key={0}>
                        <Column>
                            <Layer>{ResultPartB}</Layer>
                            <Layer>{ResultPartC}</Layer>
                        </Column>
                    </Container>
                    {/*<SearchContainer className={'layout-container'}>*/}
                    <div className={`popup-chart-modal ${DisplayClassName}`}>
                        <ChartContainer className={DisplayClassName}>
                            <ChartBG>
                                <BGTopLayer>
                                    <BGSquare>
                                        <YearSelecter />
                                    </BGSquare>
                                    <BGTriangle />
                                    <CloseClick onClick={close} />
                                </BGTopLayer>
                                <TableContent>
                                    <SearchDataChart year={year} reset={Math.random()}>
                                        <FBbuttonContainer>
                                            <FBshareButton />
                                        </FBbuttonContainer>
                                    </SearchDataChart>
                                </TableContent>
                            </ChartBG>
                        </ChartContainer>
                        <Mask className={DisplayClassName} onClick={close} />
                    </div>
                    {/*</SearchContainer>*/}
                </>
            );
        } else {
            return (
                <>
                    <ShareToFriends>
                        <div>
                            分享給你身邊叫
                            <ShareFriendName
                                onKeyDown={(event) => ShareFriendNameEnter(event)}
                                type="text"
                                id="ShareName"
                                value={friendName}
                                onChange={(e) => setFriendName(e.target.value)}
                            />
                            的朋友吧！
                        </div>
                        <ShareIcon target={"_blank"} onClick={() => SerachName()} />
                    </ShareToFriends>
                    <Container key={0}>
                        <Layer>{ResultPartA}</Layer>
                        <Column>
                            <Layer>{ResultPartB}</Layer>
                            <Layer>{ResultPartC}</Layer>
                        </Column>
                    </Container>
                    {/*<SearchContainer className={'layout-container'}>*/}
                    <div className={`popup-chart-modal ${DisplayClassName}`}>
                        <ChartContainer className={DisplayClassName}>
                            <ChartTopBar>
                                <ResultYearSelector value={year} onChange={(e) => changeYear(parseInt(e.target.value))}>
                                    <YearChangeOptions />
                                </ResultYearSelector>
                                <FBbuttonContainer className={"top-bar-inner"}>
                                    <FBshareButton />
                                </FBbuttonContainer>
                                <CloseClick onClick={close} />
                            </ChartTopBar>
                            <SearchDataChart year={year} reset={Math.random()} />
                        </ChartContainer>
                        <Mask className={DisplayClassName} onClick={close} />
                    </div>
                    {/*</SearchContainer>*/}
                </>
            );
        }
    };

    useEffect(() => {}, []);

    if (isMobile || isTablet) {
        return (
            <>
                <Subtitle>全澳最常用名字</Subtitle>
                <Part3BackGround>
                    <YearSelecter />
                    <LoopName />
                </Part3BackGround>
            </>
        );
    } else {
        return (
            <>
                <Subtitle>全澳最常用名字</Subtitle>
                <Part3BackGround>
                    <LoopName />
                    <YearSilder />
                </Part3BackGround>
            </>
        );
    }
}

export default Part3;
